import * as Sentry from "@sentry/nextjs";

export const logger = (
  message: string,
  logType?: "error" | "info",
  additionalInfo?: Record<string, string | number | boolean | string[]>
): void => {
  switch (logType) {
    case "error":
      console.error(message);
      Sentry.captureException(new Error(message), (scope) => ({
        ...scope,
        additionalInfo,
      }));
      break;
    case "info":
    default:
      console.log(message);
  }
};
